import { useState } from 'react';

// Material UI
import { Grid, Button, Container } from '@mui/material';
import { Add } from '@mui/icons-material';

import Swal from 'sweetalert2';

// Componentes
import AdminLayout from '@components/MainPage/AdminLayout';
import ActionHeader from '@components/Containers/ActionHeader';
import LoadingForm from '@components/LinearProgress/LoadingForm';
import TableGaleria from '@components/ppm/TableGaleria';
import FormGaleria from '@components/ppm/FormGaleria';

//SERVICES
import ppmServices from '@services/PpmServices';

//UTILS
import { convertBase64 } from '@utils/Utilities';

const EventosGaleria = () => {
    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [refreshApi, setRefreshApi] = useState(false);
    const titleModal = 'Agregar galería de evento';

    const handleInsertData = async (values) => {
        try {
            setLoading(true);

            // Eliminar 'deletedImages' del objeto 'values'
            const { deletedImages, ...valuesWithoutDeletedImages } = values;

            // Procesamos todos los archivos
            const updatedFiles = await Promise.all(valuesWithoutDeletedImages.files.map(async (fileObj) => {
                let { file } = fileObj;

                if (typeof file === "string" && file.startsWith("data:image")) {
                    // Ya es base64, no es necesario convertirlo
                    return fileObj;
                } else {
                    // Convertimos a base64 si no lo está
                    const base64File = await convertBase64(file);
                    return { ...fileObj, file: base64File };
                }
            }));

            valuesWithoutDeletedImages.files = updatedFiles;

            const result = await ppmServices.setEventGallery(valuesWithoutDeletedImages);

            if (result.results) {
                setRefreshApi((prev) => !prev);
                Swal.fire({ title: result.message, icon: 'success', customClass: { container: 'modal-alert' } });
                setOpenModal(false);
            } else {
                throw new Error(result.message);
            }
        } catch (error) {
            Swal.fire({ title: error.message, icon: 'warning', customClass: { container: 'modal-alert' } });
        } finally {
            setLoading(false);
        }
    };

    return (
        <AdminLayout>
            <Container maxWidth={false}>
                <ActionHeader title={'Galería eventos PPM'} isCustom={true}>
                    <Button
                        variant="contained"
                        color="primaryDark"
                        size="small"
                        endIcon={<Add />}
                        onClick={() => setOpenModal(true)}
                    >
                        Agregar Nuevo
                    </Button>
                </ActionHeader>
                <LoadingForm
                    isLoading={loading}
                    isOpen={loading}
                    setIsOpen={() => setLoading(!loading)}
                    loadinMessage={'Cargando...'}
                />
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TableGaleria setIsLoading={(e) => setLoading(e)} refresh={refreshApi} />
                    </Grid>
                </Grid>
                {openModal && (
                    <FormGaleria
                        setModalOpen={setOpenModal}
                        modalOpen={openModal}
                        title={titleModal}
                        setData={handleInsertData}
                    />
                )}
            </Container>
        </AdminLayout>
    );
};

export default EventosGaleria;
